module.exports = __webpack_public_path__ + "media/fonts/ProximaNova-RegularIt-e6dd91d6.eot";